

import { onUnmounted, ref } from '@vue/composition-api'
import {FilterServices} from './services'

export default function filter(type) {


  const areasOwnersOptions = ref([])
  const areasContractsOptions = ref([])
  const areasContractsOptions_orig=ref([])
  const areasCategoriesOptions = ref([])




  FilterServices.getFilterOptionsBy(type)
  
    .then(response => {
     
      const { 
      categories, groups, contracts, owners, managers, roles, types } = response.data.data
      areasOwnersOptions.value = owners
      areasContractsOptions.value = contracts
      areasContractsOptions_orig.value=contracts
      areasCategoriesOptions.value = categories
    




    })


  return {
    areasOwnersOptions,
   
    areasCategoriesOptions,
    areasContractsOptions,
    areasContractsOptions_orig,



  }

}
